var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('div',{staticStyle:{"width":"100%","background":"white"},attrs:{"id":"gantt-chart-canvas"}}),(Object.keys(_vm.chartData).length !== 0)?_c('GanttChart',{attrs:{"chartData":_vm.chartData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }